import * as React from 'react';
import PropTypes from 'prop-types';

const SvgSportsOtherNormalXsmall = React.forwardRef(
  ({ color, size, title, titleId, ...props }, ref) => (
    <svg
      fill={color}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 16 16"
      ref={ref}
      width={size}
      height={size}
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <path
        d="M15 3.5h-3.187a1.767 1.767 0 00-1.564.94s-.79 1.537-.83 1.56a.112.112 0 01-.12 0c-.04-.025-2.383-4.483-2.383-4.483a1.1 1.1 0 00-1.873 0L4.2 3.092a.772.772 0 01-.682.41H1.01v1h2.51a1.772 1.772 0 001.566-.94s.8-1.552.836-1.574a.1.1 0 01.107 0c.036.021 2.384 4.483 2.384 4.483a1.07 1.07 0 001.888 0l.83-1.563a.77.77 0 01.68-.409H15V3.5z"
        fill=""
      />
      <path
        d="M15 7.488h-3.188a1.767 1.767 0 00-1.564.94s-.79 1.538-.831 1.562a.107.107 0 01-.121 0C9.255 9.966 6.91 5.506 6.91 5.506a1.1 1.1 0 00-1.873 0L4.2 7.08a.769.769 0 01-.681.41H1.008v1H3.52a1.767 1.767 0 001.564-.94s.8-1.552.837-1.574a.1.1 0 01.107 0C6.064 6 8.413 10.46 8.413 10.46a1.07 1.07 0 001.887 0l.83-1.56a.77.77 0 01.682-.409H15V7.488z"
        fill=""
      />
      <path
        d="M10.248 12.443s-.79 1.537-.831 1.562a.111.111 0 01-.121 0C9.255 13.98 6.91 9.521 6.91 9.521a1.1 1.1 0 00-1.873 0L4.2 11.1a.77.77 0 01-.681.409H1.008v1H3.52a1.766 1.766 0 001.564-.94s.8-1.552.837-1.573a.1.1 0 01.107 0c.036.021 2.385 4.483 2.385 4.483a1.068 1.068 0 001.887 0l.83-1.563a.77.77 0 01.682-.409H15v-1h-3.188a1.768 1.768 0 00-1.564.936z"
        fill=""
      />
    </svg>
  )
);
SvgSportsOtherNormalXsmall.defaultProps = {
  color: 'currentColor',
  size: 16,
  title: undefined,
  titleId: undefined
};
SvgSportsOtherNormalXsmall.propTypes = {
  color: PropTypes.string,
  size: PropTypes.number,
  title: PropTypes.string,
  titleId: PropTypes.string
};
export default SvgSportsOtherNormalXsmall;
